import { DirectDebitfileConfigModel } from "../../instance/models/direct-debitfile-config.model";
import { TwoFAConfigModel } from "../../instance/models/instance.model";

export class OrganizationModel {
    public organizationID: number;
    public organizationMasterHashId: string;
    public organizationName: string;
    public ContactPersonHashID: string;
    public contactPersonName: string;
    public isActive: boolean;
    public organizationAddressModel: OrganizationAddressModel;
    public instanceId: string;
    public instanceHashId: string;
    public orgnizationGeoLocationAddress: string;
    public displayorganizationGeoLocationAddress: string;
    public organizationGeoLocationLatitude: number;
    public organizationGeoLocationLongitude: number;
    public isChecked: boolean;
    public companyMasterHashId: string;
    public companyName: string = "";
    public instanceName: string = "";
    public adminCount: number;
    public subscriptionCount: number;
    public driverCount: number;
    public isEditable: boolean;
    public preferredlanguage: string;
    public debtornr: string;
    public vatnr: string;
    public isDeletable: boolean;
    public isSubscriptionCount: boolean;
    public isDriverCount: boolean;
    public isAdminCount: boolean;
    public invoiceInterval:string='YEARLY';
    public directDebitBillingInfoModel: DirectDebitBillingInfoModel;
    public invoiceMomentDayOfWeek:string;
    public sendInvoiceToDriver: string = "INHERIT";
    public sendInvoiceToOrganization: string = "INHERIT";
    public isBlocked: boolean;
    public userBlockMessage:string='';
    public twoFAConfig: TwoFAConfigModel;
    constructor() {
        this.organizationAddressModel = new OrganizationAddressModel();
        this.directDebitBillingInfoModel = new DirectDebitBillingInfoModel();
        this.twoFAConfig = new TwoFAConfigModel();
    }
}

export class DirectDebitBillingInfoModel {
    public directDebitFileEnabledOnInstance: boolean=false;
    public subjectToDirectDebit: boolean=false;
    public isAmendment: boolean = false;
    public iBANNumber: string;
    public bICCode: string;
    public mandateId: string;
    public mandateSignatureDate: Date;
    public vatNumber: string;
}

export class OrganizationAddressModel {
    public houseNo: string;
    public houseExtention: string;
    public street: string;
    public city: string;
    public zipCode: string;
}

export class OrganizationDropDownModel {
    public organizationMasterHashId: string;
    public organizationName: string;
}
export class OrganizationBlockModel {
    public organizationMasterHashId: string;
    public reason: string;
    public activeFlag: boolean;
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/models/organization.model.ts